export function toOption(v) {
    if (v && typeof v === 'object' && 'value' in v) return v;
    return { value: v, label: String(v) };
}


export function normalizeOptions(arr = []) {
    return (arr || []).map(toOption);
}


export function withAll(options, allValue = 'All', allLabel = 'All') {
    const exists = (options || []).some(o => o.value === allValue);
    return exists ? options : [{ value: allValue, label: allLabel }, ...(options || [])];
}


export async function resolveOptions({ options, loadOptions }) {
    if (Array.isArray(options) && options.length) return normalizeOptions(options);
    if (typeof loadOptions === 'function') {
        const data = await loadOptions();
        return normalizeOptions(data || []);
    }
    return [];
}